// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { keyedReviver } = require('client-v2/common/state/revivers')

class PageContextOverlayRecord extends Immutable.Record({
  // Defer to global page context values if not specified
  pageName: undefined,
  pageSection: undefined,
  recBatchId: undefined,
  recId: undefined,
  streamId: undefined,
  streamKey: undefined,
  streamType: undefined
}) {
  // No methods
}

PageContextOverlayRecord.reviver = keyedReviver(PageContextOverlayRecord, {
  // No nested data structures
})

class PageContextOverrideRecord extends Immutable.Record({
  // Defer to global page context values if not specified
  pageName: undefined,
  pageSection: undefined,
  // Override global page context stream meta values
  recBatchId: null,
  recId: null,
  streamId: null,
  streamKey: null,
  streamType: null
}) {
  // No methods
}

PageContextOverrideRecord.reviver = keyedReviver(PageContextOverrideRecord, {
  // No nested data structures
})

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')

  const propTypes = {
    pageName: PropTypes.string,
    pageSection: PropTypes.string,
    recBatchId: PropTypes.string,
    recId: PropTypes.string,
    streamId: PropTypes.oneOfType([
      PropTypes.string, // url_id
      PropTypes.number // All other ids
    ]),
    streamKey: PropTypes.string,
    streamType: PropTypes.string
  }

  PageContextOverlayRecord.propTypes = propTypes
  PageContextOverrideRecord.propTypes = propTypes
}

module.exports = {
  PageContextOverlayRecord,
  PageContextOverrideRecord
}
